import { MetaData } from "constants/metadata";
import { compact, flow, join } from "lodash/fp";
import { Helmet } from "react-helmet";

interface Props {
  title?: string;
  description?: string;
  image?: string;
  slug?: string;
  isBlogPost?: boolean;
}

const KEYWORDS = [
  "Krit Kruaykitanon",
  "กฤต กรวยกิตานนท์",
  "kritkruaykitanon.com",
  "OozyGrub",
  "Ou.wildlife",
  "ou.wildlife",
  "wildlife thailand",
  "ดูนก",
  "bird watching thailand",
  "wildlife photography",
].join(", ");

const DEFAULT_DESCRIPTION =
  "Krit Kruaykitanon (กฤต กรวยกิตานนท์) — wildlife photographer and bird watcher based in Thailand. Gallery of birds, butterflies, and fauna from across Thailand and beyond.";

export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image = "/logo/logo-600-bg.png",
  slug,
  isBlogPost = false,
}: Props) => {
  const seoTitle = flow(compact, join(" | "))([title, "kritkruaykitanon.com"]);
  const canonicalUrl = slug
    ? `${MetaData.websiteUrl}/blog/${slug}`
    : MetaData.websiteUrl;

  const meta = [
    {
      property: "charset",
      content: "utf-8",
    },
    {
      property: "keywords",
      content: KEYWORDS,
    },
    {
      property: "author",
      content: "Krit Kruaykitanon",
    },
    {
      property: "theme-color",
      content: "#556b2f",
    },
    {
      name: "viewport",
      content: "width=device-width, initial-scale=1",
    },
    {
      property: "description",
      content: description,
    },
    {
      property: "og:description",
      content: description,
    },
    {
      property: "og:url",
      content: canonicalUrl,
    },
    {
      property: "og:site_name",
      content: "Krit Kruaykitanon",
    },
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: seoTitle,
    },
    {
      name: "twitter:description",
      content: description,
    },
    {
      name: "twitter:image",
      content: `${MetaData.websiteUrl}${image}`,
    },
    {
      name: "twitter:creator",
      content: "@kritkruaykitanon",
    },
    {
      property: "image",
      content: image,
    },
    {
      property: "og:image",
      content: image,
    },
    {
      property: "og:image:secure_url",
      content: image,
    },
    {
      property: "og:title",
      content: seoTitle,
    },
    {
      property: "fb:app_id",
      content: MetaData.facebookAppId,
    },
    {
      property: "og:type",
      content: isBlogPost ? "article" : "website",
    },
    {
      property: "og:locale",
      content: "th_TH",
    },
    {
      property: "og:locale:alternate",
      content: "en_US",
    },
  ];

  return <Helmet meta={meta} title={seoTitle} />;
};
